import { FormField, SelectBox } from '@domain-group/suit-theme'

import type { ServiceCategoryModel } from '@models/types'
import type { UseNewOrderPayload } from '@modals/NewOrderModal'

interface CategorySelectorProps {
  callbacks: {
    selectCategoryId: UseNewOrderPayload['callbacks']['selectCategoryId'],
  },
  selectedCategoryId: number,
  serviceCategories: ServiceCategoryModel[],
}

const CategorySelector = (props: CategorySelectorProps) => {
  const {
    callbacks: {
      selectCategoryId,
    },
    selectedCategoryId,
    serviceCategories,
  } = props

  return (
    <FormField label="Select Category">
      <SelectBox
        callbacks={{
          selectItem: (item: { key: number }) => selectCategoryId(item.key),
        }}
        items={serviceCategories.map(category => ({ key: category.id, title: category.title }))}
        selectedItemKey={selectedCategoryId}
        style={{ zIndex: 15 }}
      />
    </FormField>
  )
}

export default CategorySelector
